import { Dialog, DialogContent } from '@goaltree/ui/components/dialog'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { LoginForm } from '@/components/login-form'
import { useOnboardingStore } from '@/store/onboarding.store'

export default function SignUpGate({ onStartOver }: { onStartOver?: () => void }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)

  function handleOpen() {
    useOnboardingStore.getState().setAutoSaveAfterAuth(true)
    setOpen(true)
  }

  function handleComplete() {
    setOpen(false)
  }

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 border-t border-border/60 bg-background/80 p-4 backdrop-blur-sm">
        <div className="mx-auto flex max-w-2xl flex-col gap-2">
          <button
            type="button"
            onClick={handleOpen}
            className="cursor-pointer group flex w-full items-center justify-center gap-2 rounded-full bg-primary py-3.5 text-sm font-bold text-white dark:text-[#0a0a0a] transition-all hover:bg-[#bfff5c] hover:scale-[1.01] active:scale-[0.99]"
          >
            {t('onboarding.savePlan')}
            <svg
              className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M3 8h10M9 4l4 4-4 4"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          {onStartOver && (
            <button
              type="button"
              onClick={onStartOver}
              className="cursor-pointer flex w-full items-center justify-center rounded-full border border-border/60 py-2.5 text-sm font-medium text-muted-foreground transition-colors hover:border-border hover:text-foreground"
            >
              {t('onboarding.startOver')}
            </button>
          )}
        </div>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <LoginForm
            onComplete={handleComplete}
            returnTo="/goals/new/preview"
            surface="modal"
            title={t('onboarding.flow.saveTitle')}
            subtitle={t('onboarding.flow.saveHint')}
          />
          <button
            type="button"
            onClick={() => setOpen(false)}
            className="cursor-pointer text-center text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
          >
            {t('onboarding.flow.editFirst')}
          </button>
        </DialogContent>
      </Dialog>
    </>
  )
}
